import { getAzureApiToken } from '@/helpers/azure/apiToken';

export const getUser = id => getAzureApiToken()
  .then(token => fetch(`https://graph.microsoft.com/v1.0/users/${id}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then(res => res.json()));
